import { render, staticRenderFns } from "./EcoScoreTruckView.vue?vue&type=template&id=84fbde80&scoped=true&"
import script from "./EcoScoreTruckView.vue?vue&type=script&lang=js&"
export * from "./EcoScoreTruckView.vue?vue&type=script&lang=js&"
import style0 from "./EcoScoreTruckView.vue?vue&type=style&index=0&id=84fbde80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fbde80",
  null
  
)

/* custom blocks */
import block0 from "./EcoScoreTruckView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports